<script lang="ts">
    import { _ } from "svelte-i18n"
    import { optionsConf } from "../../config"
    import { formatPriceCurrency, langField } from "../../i18n"

    import { checkoutData, login } from "../../store"
    import { getProductPrice } from "../../utils"

    export let product: Product
    export let color: RALColor = undefined
    export let options: string[] = []
    $: quboMatt = product.code.toString().match(/^23/) ? " matt" : ""
</script>

<div class="product_summary">
    <div class="left">
        <div class="title">{langField(product.name, "")}</div>
        <div class="artnr">
            {$_("product.item-number-short")}
            {product.code}
        </div>
        <div class="price">
            {$formatPriceCurrency(getProductPrice(product, color, options, !!$login), $login ? 0 : $checkoutData.vat)}
        </div>
        <div class="mwst">
            {#if $login}
                {$_("product.retail-price-excl-vat")}
            {:else}
                {$_("product.retail-price-incl-vat")}
            {/if}
        </div>
    </div>
    <div class="right">
        {#if color}
            <div class="colors">
                <div class="color" style="background:{color.HEX};"></div>
                <div class="value">RAL {color.RAL}{quboMatt}</div>
            </div>
        {/if}
        <div class="options">
            {#each options || [] as o}
                <div class="value">{optionsConf[o]?.title}</div>
            {/each}
        </div>
    </div>
</div>

<style lang="less">
    @import "../../css/variables.less";

    .product_summary {
        border-bottom: 1px solid var(--border-color-default);
        margin-bottom: 30px;
        padding: 10px 0px;
        .flex();
        .left {
            .title {
                margin-right: 15px;
                font-weight: 700;
                font-size: 1rem;
                line-height: 1.2;
            }
            .artnr {
                display: block;
                font-size: 0.7rem;
                font-weight: 400;
            }
            .price {
                font-size: 1.2rem;
                color: var(--primary);
            }
        }

        .right {
            width: 150px;
            flex-shrink: 0;
            @media (max-width: 768px) {
                width: 100px;
            }
            .colors {
                border-bottom: 1px solid var(--border-color-default);
                padding-bottom: 10px;
                margin-bottom: 10px;
                .flex();
                .color {
                    width: 25px;
                    height: 25px;
                    margin-right: 10px;
                    flex-shrink: 0;
                }
            }
            .options {
                line-height: 1.2;
                .value {
                    margin-bottom: 10px;
                }
            }
        }
    }
</style>
